// @flow
import React from 'react';

import { layoutCssVars } from '../stylesHelper';

import './style.pcss';

const withSmallLayout = (items: React$Element<'div'>[]) => (
  <div className='small-layout'>
    {items.map(item => (
      <div
        key={item.key}
        style={layoutCssVars.SMALL}
        className='small-layout__item'
      >
        {item}
      </div>
    ))}
  </div>
);

export default withSmallLayout;
